import { render, staticRenderFns } from "./min-term-cell.vue?vue&type=template&id=732b3a56&"
import script from "./min-term-cell.vue?vue&type=script&lang=ts&"
export * from "./min-term-cell.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports